// extracted by mini-css-extract-plugin
export default {"img":"contentful-richtext-module--img--1b7Xh"};